import { useEffect } from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import { crearUsuario } from "../../services/personas-service";

const FormUsuarios = ({ modalState, onSaved }) => {
    const usuario = modalState.data;

    const defaultValues = {
        id: usuario.id || "",
        usuario: usuario.usuario || "",
        password: "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [usuario]);

    const onCreateUsuario = async (usuario) => {
        const resp = await crearUsuario({
            ...usuario,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSaved();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formConfiguracion"
            onSubmit={onCreateUsuario}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        name="usuario"
                        label="Usuario"
                        type="text"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Usuario"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="password"
                        label="Password"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Password"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormUsuarios.propTypes = {
    modalState: PropTypes.object,
    onSaved: PropTypes.func,
};

export default FormUsuarios;
